/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} correct · ${i?.incorrect} incorrect`)
};

const es_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} correctos · ${i?.incorrect} incorrectos`)
};

const de_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} richtig · ${i?.incorrect} falsch`)
};

const nl_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} correct · ${i?.incorrect} onjuist`)
};

const fr_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} correct · ${i?.incorrect} incorrect`)
};

const it_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} corretti · ${i?.incorrect} errati`)
};

const pt_br2_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} corretos · ${i?.incorrect} incorretos`)
};

const pt_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} corretos · ${i?.incorrect} incorretos`)
};

const ja_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正解 ${i?.correct} · 不正解 ${i?.incorrect}`)
};

const zh_typing_chars_summary = /** @type {(inputs: { correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct} 个正确 · ${i?.incorrect} 个错误`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ correct: NonNullable<unknown>, incorrect: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_chars_summary = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_chars_summary(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_chars_summary", locale)
	if (locale === "en") return en_typing_chars_summary(inputs)
	if (locale === "es") return es_typing_chars_summary(inputs)
	if (locale === "de") return de_typing_chars_summary(inputs)
	if (locale === "nl") return nl_typing_chars_summary(inputs)
	if (locale === "fr") return fr_typing_chars_summary(inputs)
	if (locale === "it") return it_typing_chars_summary(inputs)
	if (locale === "pt-BR") return pt_br2_typing_chars_summary(inputs)
	if (locale === "pt") return pt_typing_chars_summary(inputs)
	if (locale === "ja") return ja_typing_chars_summary(inputs)
	return zh_typing_chars_summary(inputs)
};